import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { videoDataRequest } from "../../../modules/students-modules/videos/Actions";
import "./style.css";
/**
 * Component consuming the VdocipherAPI
 */
export default function VideoStatusUsingAPI({ videoRef, isAPIReady, videoId: videoIdProp }) {
  const [status, setStatus] = useState("NA");
  const [player, setPlayer] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [searchParams] = useSearchParams();
  const params = useParams();

  const [totalPalyed, setTotalPlayed] = useState(null);
  const [totalCoverd, setTotalCoverd] = useState(null);

  const userData = useSelector((state) => state.user.userData);
  const videoData = useSelector((state) => state.chapterVideos.videoData);
  const dispatch = useDispatch();

  const [start, setStart] = useState(0);

  const queryVideoId = searchParams.get("video");
  const routeVideoId = params?.id;

  const resolvedVideoId = useMemo(() => {
    if (videoIdProp != null && videoIdProp !== "") return videoIdProp;
    if (queryVideoId != null && queryVideoId !== "") return queryVideoId;
    if (routeVideoId != null && routeVideoId !== "") return routeVideoId;
    return null;
  }, [videoIdProp, queryVideoId, routeVideoId]);

  useEffect(() => {
    if (!isAPIReady) return;
    if (!videoRef) {
      // @todo detach from the API
      //console.log("No");
      setPlayer(null);
      return;
    }
    const player = new window.VdoPlayer(videoRef);
    window.player = player;
    setPlayer(player);
    player.video.addEventListener("play", () => setStatus("Playing"));
    player.video.addEventListener("pause", () => setStatus("pause"));
    player.video.addEventListener("canplay", () => setStatus("Ready"));
    player.video.addEventListener("timeupdate", () => {
      setCurrentTime(player.video.currentTime);
    });

    window.player = player;
  }, [isAPIReady, videoRef]);

  useEffect(() => {
    if (player) {
      player.api.getTotalPlayed().then((data) => {
        let diff = data - start;
        setStart(data);
        setTotalPlayed(diff);
      });

      setTotalCoverd(player.video.currentTime);
    }
  }, [player, status]);

  useEffect(() => {
    if (!resolvedVideoId || userData?.id == null) return;
    if (!(totalPalyed && totalCoverd)) return;

    dispatch(
      videoDataRequest({
        total_played: totalPalyed,
        total_covered: totalCoverd,
        video_id: resolvedVideoId,
        user_id: userData?.id,
      })
    );
  }, [totalCoverd, totalPalyed, resolvedVideoId, userData?.id, dispatch]);

  useEffect(() => {
    if (videoData.views_count > 3) {
      window.location.reload();
    }
  }, [videoData]);

  return <></>;
}
